import {EnvironmentHelper} from "@/mixins/AuthorizationHelpers/EnvironmentHelper";
import {CompanyHelper} from "@/mixins/AuthorizationHelpers/CompanyHelper";
import {PermissionHelper} from "@/mixins/AuthorizationHelpers/PermissionHelper";
import {FeatureLevelHelper} from "@/mixins/AuthorizationHelpers/FeatureLevelHelper";

import _ from 'lodash'
import axios from "axios";

export const SonicuCoreMixin = {
    data() {
        return {
            csrf: '',
            environment: null,
            company: null,
            permissions: null,
            featureLevel: null,
            STRICT_CONFIRMATION_OPTION: 'StrictConfirmationsOption',

            _autoUpdating: [],
        }
    },
    created() {
        // Features & Permissions Objects are both declared on app.vue
        this.environment = new EnvironmentHelper()
        this.company = new CompanyHelper()
        this.permissions = new PermissionHelper(this)
        this.featureLevel = new FeatureLevelHelper(this)

        // TODO. Add Helper for Feature Flags

        // TODO Add Helper for Window / Location (Changing location etc.)

        this.sonicuCoreLoadCompany()
    },
    mounted() {
        this.csrf = document.head.querySelector('meta[name="csrf-token"]').content;
        this.autoUpdateOnCoreChanges(this.company.getCompanyId())
    },
    methods: {
        sonicuCoreLoadCompany(company = null) {
            company = _.isNil(company)
                    ? this.company.getCompanyId()
                    : company

            // Trigger loads w/ company
            this.permissions.loadCompany(company)
            this.featureLevel.loadCompany(company)
        },

        autoUpdateOnCoreChanges(company = null) {
            company = this.currentCompanyIfNull(company)
            if (_.indexOf(this.$data._autoUpdating, company) !== -1) {
                return
            }

            // Feature Level Listener
            this.featureLevel.addListener('FeatureLevel.forceUpdate', company => {
                this.$forceUpdate()
            }, company)

            // Permission level listener
            this.permissions.addListener('Permissions.forceUpdate', company => {
                this.$forceUpdate()
            }, company)

            this.$data._autoUpdating.push(company)
        },
        currentCompanyIfNull(company = null) {
            return _.isNil(company)
                    ? this.company.getCompanyId()
                    : company
        },

        featureFlagValuePromise(featureFlagName, companyId = null){
            if(companyId === null){
                companyId = this.company.getCompanyId();
            }

            return axios.get(this.company.buildCompanyApiInternalRoute('options/' + featureFlagName, companyId), {validateStatus: false})
                    .then(response => {
                        if(response.status !== 200){
                            return null;
                        }
                        if(response.data.data.hasOwnProperty('value')){
                            return response.data.data['value'];
                        }
                    });
        }
    },
    computed: {

    },
}
